import React from "react";

// Style \\
import "../../assets/styles/sections/reason.scss";

// Icons \\
import { HiOutlineShoppingBag } from "react-icons/hi2";

// Images \\

const Reason = () => {
  return (
    <section className="reason">
      <div className="containers">
        <div className="reason_items">
          <div className="title text-center">
            <h3>Why do they choose us?</h3>
            <p className="text-xl w-2/4">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam
              commodo, arcu quis luctus fringilla, nisi est tincidunt lectus,
              sed luctus enim lectus vel libero
            </p>
          </div>

          <div className="card_box flex justify-between">
            <div className="cardReason">
              <div className="card_icons text-center">
                <HiOutlineShoppingBag className="icon_shop" />
              </div>
              <div className="title">
                <h4>Marketplace</h4>
                <p className="">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Doloribus?
                </p>
              </div>
            </div>
            <div className="cardReason">
              <div className="card_icons text-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="65"
                  height="66"
                  viewBox="0 0 65 66"
                  fill="none"
                >
                  <path
                    d="M63.5577 28.4149L59.1374 23.2795C58.2924 22.3045 57.6098 20.4844 57.6098 19.1843V13.6589C57.6098 10.2137 54.7822 7.38607 51.337 7.38607H45.8116C44.5441 7.38607 42.6914 6.70353 41.7164 5.85848L36.5811 1.43821C34.3384 -0.479404 30.6657 -0.479404 28.3906 1.43821L23.2877 5.89098C22.3126 6.70353 20.46 7.38607 19.1924 7.38607H13.5696C10.1244 7.38607 7.29669 10.2137 7.29669 13.6589V19.2168C7.29669 20.4844 6.61415 22.3045 5.8016 23.2795L1.41383 28.4474C-0.471278 30.69 -0.471278 34.3302 1.41383 36.5729L5.8016 41.7407C6.61415 42.7157 7.29669 44.5358 7.29669 45.8034V51.3612C7.29669 54.8064 10.1244 57.6341 13.5696 57.6341H19.1924C20.46 57.6341 22.3126 58.3167 23.2877 59.1617L28.4231 63.582C30.6657 65.4996 34.3384 65.4996 36.6136 63.582L41.7489 59.1617C42.7239 58.3167 44.5441 57.6341 45.8441 57.6341H51.3695C54.8147 57.6341 57.6423 54.8064 57.6423 51.3612V45.8359C57.6423 44.5683 58.3249 42.7157 59.1699 41.7407L63.5902 36.6054C65.4753 34.3627 65.4753 30.6575 63.5577 28.4149ZM46.0066 26.3672L30.3082 42.0657C29.8532 42.5207 29.2356 42.7807 28.5856 42.7807C27.9356 42.7807 27.318 42.5207 26.863 42.0657L18.9974 34.2002C18.0548 33.2577 18.0548 31.6976 18.9974 30.755C19.9399 29.8125 21.5 29.8125 22.4426 30.755L28.5856 36.8979L42.5614 22.922C43.504 21.9794 45.0641 21.9794 46.0066 22.922C46.9492 23.8646 46.9492 25.4247 46.0066 26.3672Z"
                    fill="rgba(71, 41, 12, 1)"
                  />
                </svg>
              </div>
              <div className="title">
                <h4>Original</h4>
                <p className="">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Doloribus?
                </p>
              </div>
            </div>
            <div className="cardReason">
              <div className="card_icons text-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="76"
                  height="68"
                  viewBox="0 0 76 68"
                  fill="none"
                >
                  <path
                    d="M71.6667 10.6667L35 10.6667"
                    stroke="rgba(71, 41, 12, 1)"
                    stroke-width="6.75288"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M21.6667 10.6667L5 10.6667"
                    stroke="rgba(71, 41, 12, 1)"
                    stroke-width="6.75288"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M71.6667 34H55"
                    stroke="rgba(71, 41, 12, 1)"
                    stroke-width="6.75288"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M41.6667 34H5"
                    stroke="rgba(71, 41, 12, 1)"
                    stroke-width="6.75288"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M70.6667 57.3333H34"
                    stroke="rgba(71, 41, 12, 1)"
                    stroke-width="6.75288"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M20.6667 57.3333H4"
                    stroke="rgba(71, 41, 12, 1)"
                    stroke-width="6.75288"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M34 64V50.6667"
                    stroke="rgba(71, 41, 12, 1)"
                    stroke-width="6.75288"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M35 17.3334V4.00004"
                    stroke="rgba(71, 41, 12, 1)"
                    stroke-width="6.75288"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M41.6667 40.6667V27.3334"
                    stroke="rgba(71, 41, 12, 1)"
                    stroke-width="6.75288"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div className="title">
                <h4>Selection</h4>
                <p className="">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Doloribus?
                </p>
              </div>
            </div>
            <div className="cardReason">
              <div className="card_icons text-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="90"
                  height="89"
                  viewBox="0 0 90 89"
                  fill="none"
                >
                  <path
                    d="M35.3879 51.6078C35.3879 55.538 38.4267 58.6983 42.1543 58.6983H49.7716C53.013 58.6983 55.6466 55.9431 55.6466 52.4992C55.6466 48.8121 54.0259 47.475 51.6354 46.6242L39.4397 42.3698C37.0491 41.519 35.4285 40.2224 35.4285 36.4948C35.4285 33.0913 38.0621 30.2957 41.3035 30.2957H48.9207C52.6483 30.2957 55.6871 33.456 55.6871 37.3862"
                    stroke="rgba(71, 41, 12, 1)"
                    stroke-width="6.07759"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M45.5173 26.2845V62.75"
                    stroke="rgba(71, 41, 12, 1)"
                    stroke-width="6.07759"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M85.0346 44.5173C85.0346 66.8828 66.8828 85.0346 44.5173 85.0346C22.1517 85.0346 4 66.8828 4 44.5173C4 22.1517 22.1517 4 44.5173 4"
                    stroke="rgba(71, 41, 12, 1)"
                    stroke-width="6.07759"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M65.7759 8.05176V24.2587H81.9828"
                    stroke="rgba(71, 41, 12, 1)"
                    stroke-width="6.07759"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M86.0345 4L65.7759 24.2586"
                    stroke="rgba(71, 41, 12, 1)"
                    stroke-width="6.07759"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div className="title">
                <h4>Marketplace</h4>
                <p className="">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Doloribus?
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Reason;
